<template>
  <div class="transcription-full-list">
    <div class="transcription-full-list__close">
      <span @click="$emit('close')">
        <feather type="chevrons-down" size="14" />
      </span>
    </div>
    <div class="transcription-full-list__content d-flex flex-column align-items-start">
      <p
        v-for="(item, index) in transcriptions"
        :key="index"
        class="transcription-full-list__content--item"
      >
        <strong>{{item.identity === selfIdentity ? "You" : item.identity}}: </strong>{{item.text}}
      </p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";

export default {
  name: "TranscriptionFullList",
  props: {
    selfIdentity: String,
  },
  computed: {
    ...mapGetters("transcription", ["transcriptions"]),
  }
}
</script>

<style lang="scss" scope>
.transcription-full-list {
  width: 100%;
  min-height: 170px;
  max-height: 300px;
  display: grid;
  grid-template-rows: 20px 1fr;
  background-color: black;

  &__close {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    > span {
      cursor: pointer;
      font-size: 10px;
      color: white;
      padding: 2px;
    }
  }

  &__content {
    overflow-y: auto;
    &--item {
      margin: 0;
      color: white;
      text-align: left;
    }
  }
}
</style>